import { createSelector } from 'redux-starter-kit';

export default {
  selected: createSelector(['briefings.selected']),
  list: createSelector(['briefings.list']),
};
